/**
 * The security a customer can offer at origination, named as the Tirhelo Credit Assessment Procedure
 * Manual rev01 (section 7) names its security and repayment controls (finding #6, 20 Oct 2026).
 *
 * Property is offered again after the business test of 22 Oct 2026. Debtor / invoice cession is part of
 * cession of receivables; it stays in the labels so applications captured before still read correctly.
 */
export const SECURITY_TYPE_LABELS: Record<string, string> = {
  VEHICLE: 'Vehicle',
  ASSET_TITLE_CONTROL: 'Asset finance / title control (eNaTIS)',
  CESSION_OF_PROCEEDS: 'Cession of receivables / payment proceeds',
  CESSION_OF_BANK_ACCOUNT: 'Bank account mandate / account control',
  CSD_ACCESS_CONTROL: 'CSD/other profile',
  PERSONAL_SURETY: 'Personal surety',
  CORPORATE_GUARANTEE: 'Corporate guarantee',
  OTHER: 'Other (e.g. working capital to a trusted client)',
  PROPERTY: 'Property',
  // No longer offered; kept for applications captured before
  DEBTOR_INVOICE_CESSION: 'Debtor / invoice cession',
};

/** What the application step offers, in this order. */
export const OFFERED_SECURITY_TYPES = [
  'VEHICLE',
  'PROPERTY',
  'ASSET_TITLE_CONTROL',
  'CESSION_OF_PROCEEDS',
  'CESSION_OF_BANK_ACCOUNT',
  'CSD_ACCESS_CONTROL',
  'PERSONAL_SURETY',
  'CORPORATE_GUARANTEE',
  'OTHER',
];

export const securityTypeLabel = (value: string) => SECURITY_TYPE_LABELS[value] || value;
